import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "confirm-delete-file" }
const _hoisted_2 = { class: "confirm-delete-file__header" }
const _hoisted_3 = { class: "confirm-delete-file__content" }
const _hoisted_4 = { class: "confirm-delete-file__content__title" }
const _hoisted_5 = { class: "confirm-delete-file__content__text" }
const _hoisted_6 = { class: "confirm-delete-file__footer" }

import { useI18n } from 'vue-i18n'
import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import ButtonText from '@/design-system/atoms/buttons/ButtonText.vue'
import IconTrash2Medium from '@/design-system/assets/icons/IconTrash2Medium.vue'
import IconXCircleMedium from '@/design-system/assets/icons/IconXCircleMedium.vue'
// emits
interface EMITS {
  (e: 'closeOverlay'): void
  (e: 'confirmDelete'): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmDeleteAttachmentCard',
  props: {
    buttonText: {}
  },
  emits: ["closeOverlay", "confirmDelete"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit

const { t } = useI18n()
function confirmDelete() {
  emits('confirmDelete')
  emits('closeOverlay')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[3] || (_cache[3] = _createElementVNode("span", null, null, -1)),
      _createVNode(IconTrash2Medium, { class: "confirm-delete-file__header__icon" }),
      _createElementVNode("button", {
        class: "confirm-delete-file__header__close-button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('closeOverlay')))
      }, [
        _createVNode(IconXCircleMedium, { class: "confirm-delete-file__header__close-button__icon" })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('general__text__delete')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)('general__text__delete-observe')), 1)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(ButtonText, {
        class: "confirm-delete-file__footer__button cancel",
        buttonText: _unref(t)('general__text__cancel'),
        onOnClicked: _cache[1] || (_cache[1] = ($event: any) => (emits('closeOverlay')))
      }, null, 8, ["buttonText"]),
      _createVNode(ButtonPrimary, {
        class: "confirm-delete-file__footer__button",
        buttonText: _ctx.buttonText,
        onOnClicked: _cache[2] || (_cache[2] = ($event: any) => (confirmDelete()))
      }, null, 8, ["buttonText"])
    ])
  ]))
}
}

})